// extracted by mini-css-extract-plugin
export var resizer = "_gu-0";